import { useState } from 'react'
import { BarChart3, Building2, CreditCard } from 'lucide-react'
import DailyReportsTab from './DailyReportsTab'
import ChannelReportSummaryTab from './ChannelReportSummaryTab'
import Microsoft360LenovoRechargeTab from './Microsoft360LenovoRechargeTab'

const SUB_TABS = [
  { id: 'daily-reports', label: '每日报表', icon: BarChart3 },
  { id: 'channel-summary', label: '渠道统计', icon: Building2 },
  { id: 'ms-360-lenovo-recharge', label: '特定渠道统计', icon: CreditCard }
]

export default function ReportingReportsTab() {
  const [activeSubTab, setActiveSubTab] = useState('daily-reports')

  const renderContent = () => {
    switch (activeSubTab) {
      case 'channel-summary':
        return <ChannelReportSummaryTab />
      case 'ms-360-lenovo-recharge':
        return <Microsoft360LenovoRechargeTab />
      case 'daily-reports':
      default:
        return <DailyReportsTab />
    }
  }

  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex flex-wrap gap-3">
          {SUB_TABS.map((tab) => {
            const Icon = tab.icon
            const isActive = activeSubTab === tab.id

            return (
              <button
                key={tab.id}
                onClick={() => setActiveSubTab(tab.id)}
                className={`inline-flex items-center gap-2 rounded-lg border px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'border-blue-200 bg-blue-50 text-blue-700'
                    : 'border-gray-200 bg-gray-50 text-gray-600 hover:bg-gray-100'
                }`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            )
          })}
        </div>
      </div>

      {renderContent()}
    </div>
  )
}
